import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-08',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-08.component.html',
  styleUrls: []
})
export class Article08Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'O que significa venda direta Caixa? | Casato Brasil',
    description: 'Entenda como funciona a venda direta da Caixa, quais diferenças existem em relação ao leilão e o que analisar antes de enviar uma proposta.'
  };
}
